import { withPopup } from '../lib/popup';

import TimerEditStep from './TimerEditStep';

export default withPopup(TimerEditStep);
